import { TextFieldProps, TextField } from '@material-ui/core';
import React from 'react';
import { IField } from '@hooks/useField';

export type StringFieldProps = TextFieldProps & {
    field: IField
    updateFieldStateOnChange?: boolean
    onValueChanged?: (newValue: any) => void
    onEnter?: React.KeyboardEventHandler<HTMLDivElement> | undefined
}

export function StringField ({ 
    field, 
    fullWidth, 
    helperText, 
    onValueChanged, 
    onEnter,
    onKeyDown,
    updateFieldStateOnChange, 
    ...props 
}: StringFieldProps) {
    const [_value, _setValue] = React.useState(field.value);

    //Handle Change Principal
    const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const v = e.target.value;
        
        if (v !== _value) {
            _setValue(v);
        }
    }, [_value]);

    const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" && onEnter !== undefined) {
            onEnter(e);
        }

        if (onKeyDown !== undefined) {
            onKeyDown(e);
        }
    }, [onEnter, onKeyDown]);

    //Reage à mudança do valor interno
    //Set o valor na ref
    //Chama o evento o change externo
    //Verifica se é para subir o estado automaticamente através da propriedade updateFieldStateOnChange
    React.useEffect(() => {
        field.setInputValue(_value);

        if (onValueChanged !== undefined) {
            onValueChanged(_value);
        }

        if (updateFieldStateOnChange === true && field.value !== _value) {
            field.setValue(_value);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value, onValueChanged, updateFieldStateOnChange]);

    //Reage à mudança do valor externo
    //Atualiza o valor interno pelo valor externo
    React.useEffect(() => {
        if (field.value !== _value) {
            _setValue(field.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);

    React.useEffect(() => {
        if (field.transition === "reset") {
            _setValue(field.initialValueRef?.current);
            field.clearTransition();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.transition]);

    return (
        <TextField
            {...props}
            onKeyDown={handleKeyDown}
            name={field.name}
            value={_value !== undefined && _value !== null ? _value : ""}
            onChange={handleChange}
            fullWidth={fullWidth !== false}
            helperText={!!field.error ? field.error : helperText}
            error={!!field.error}
        />
    )
}
